<template>
  <div id="AlumniReport">
    <div class="container">
      <div style="background: white">
        <K2Row justify_content="center" class="position-relative p-4">
          <K2Heading type="h5" class-name="mb-0" color="black">ALUMNI REPORT</K2Heading>
        </K2Row>
      </div>

      <div style="background: white" class="position-relative p-4">
        <K2Filter :filter-list="filterList" @onFilter="handleFilter" @onFilterChange="onFilterChange" :dateType="dateType" />
        <K2Button class="text-left" size="small" theme="2" @onclick="handleExport">
          {{ lang('Export') }}
        </K2Button>
        <AlumniReportTable :dataList="detailList" />
      </div>
    </div>
  </div>
</template>

<script>
import K2Heading from '../../uiComponents/k2Heading/k2Heading'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Filter from '../../uiComponents/k2Filter/k2Filter'
import AlumniReportTable from '@/pages/alumniReport/component/alumniReportTable'
import uiVariable from '../../config/uiVariable'
import DataSource from '@/data/datasource'
import { lang } from '@/locale'
import K2Button from '@/uiComponents/k2Button/k2Button'
import Export_CSV from '@/components/Export_CSV'
import { getFormatDate } from '@/helper/utily'

export default {
  name: 'AlumniReport',
  components: { K2Button, K2Heading, K2Row, K2Filter, AlumniReportTable },
  data() {
    return {
      uiVariable: uiVariable,
      selectedTab: 0,
      filterList: [
        {
          label: 'Schools',
          placeholder: 'Filter by Schools',
          optionList: [],
        },
        {
          //   label: "Level",
          //   placeholder: "Filter by Level",
          //   optionList: []
          // }, {
          label: 'Date',
          placeholder: 'Filter by date',
          selected: [],
        },
      ],

      detailList: [],
      relationshipDetailList: [],
      selectedSchool: null,
      selectedAcademic: null,
      selectedClass: null,
      dateRange: null,
      dateType: 'daterange',
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    lang,
    async init() {
      await this.getSchools()
    },
    onFilterChange(value) {
      this.getClass(value)
    },
    handleFilter(type) {
      if (this.filterList[0].selected !== undefined) {
        this.selectedSchool = this.filterList[0].selected.toString()
      }
      if (
        this.filterList[1].selected === undefined ||
        this.filterList[1].selected === '' ||
        this.filterList[1].selected === null ||
        this.filterList[1]?.selected?.length < 1
      ) {
        this.dateRange = ''
      } else {
        this.dateRange = this.filterList[1].selected.toString()

        this.tempdateListSplit = this.filterList[1].selected.toString().split(',')
        // this.tempdateListSplit = this.dateRange.split(',')
        // for( var i = 0, len = this.tempdateListSplit.length; i < len; i++ ) {
        //   this.tempdateSplit = this.tempdateListSplit[i].toString().split('/');
        //   this.tempdateListSplit[i] = this.tempdateSplit[2] + "-" + this.tempdateSplit[1] + "-" + this.tempdateSplit[0] ;
        //   this.dateRange = this.dateRange + this.tempdateListSplit[i] + ",";
        // }
        // this.dateRange = this.dateRange.replace(/,*$/, '');
        let startDate = this.tempdateListSplit?.[0] ? getFormatDate(this.tempdateListSplit?.[0], 'YYYY-MM-DD', 'DD/MM/YYYY') : ''
        let endDate = this.tempdateListSplit?.[1] ? getFormatDate(this.tempdateListSplit?.[1], 'YYYY-MM-DD', 'DD/MM/YYYY') : ''

        this.dateRange = startDate + ',' + endDate
      }

      this.loadReport()
    },
    async getSchools() {
      const response = await DataSource.shared.getSchoolDropdownList('UTY201300000061')
      if (response) {
        response.Table.forEach(d => {
          d.id = d.SchoolID
          d.label = d.SchoolName
          d.type = 'school'
        })
      }
      this.filterList[0].optionList = response.Table
    },
    async loadReport() {
      this.$vs.loading()

      try {
        const result = await DataSource.shared.GetAlumniReport(this.dateRange, this.selectedSchool)
        if (result) {
          this.detailList = result
          this.detailList.forEach(m => {
            if (m.DOB !== undefined) {
              let tempDate = new Date(m.DOB)
              m.DOB = tempDate.getDate() + '/' + (tempDate.getMonth() + 1) + '/' + tempDate.getFullYear()
            } else {
              m.DOB = ''
            }
          })
        }
      } catch (e) {
        console.log('get report err', e)
      }
      try {
        const result = await DataSource.shared.GetAlumniRelationshipReport(this.dateRange, this.selectedSchool)
        if (result) {
          this.relationshipDetailList = result
        }
      } catch (e) {
        console.log('get relationship report err', e)
      }
      this.$vs.loading.close()
    },
    async handleExport() {
      let finalExportList = []
      if (this.detailList.length > 0) {
        let add1 = ''
        let add2 = ''
        let add3 = ''
        this.detailList.forEach((m, index) => {
          if (m.address_1) {
            add1 = m.address_1
          }
          if (m.address_2) {
            add2 = m.address_2
          }
          if (m.address_3) {
            add3 = m.address_3
          }
          let tempRow = {
            'reference ': m.reference,
            'user_groups ': m.user_groups,
            Title: m.Title,
            first_name: m.first_name,
            Last_name: m.Last_name,
            maiden_name: m.maiden_name,
            Middle_name: m.Middle_name,
            preferred_first_name: m.preferred_first_name,
            suffix_1: m.suffix_1,
            DOB: m.DOB,
            from: m.from,
            to: m.to,
            gender: m.gender,
            class_of: m.class_of,
            start_year_group: m.start_year_group,
            end_year_group: m.end_year_group,
            house: m.house,
            default: m.default,
            email: m.email,
            addition_email_type: m.addition_email_type,
            additional_email: m.additional_email,
            address_type: m.address_type,
            address_1: add1,
            address_2: add2,
            address_3: add3,
            address_city: m.address_city,
            address_county_state: m.address_county_state,
            st_prm_add_country: m.st_prm_add_country,
            st_prm_add_pstcode: m.st_prm_add_pstcode,
            phone_number_type: m.phone_number_type,
            phone_country_code: m.phone_country_code,
            phone_number: m.phone_number,
            mobile_country_code: m.mobile_country_code,
            mobile_number: m.mobile_number,
            Nationality: m.Nationality,
            industry_experience: m.industry_experience,
            note_category: m.note_category,
            notes: m.notes,
            deceased: m.deceased,
            deceased_date: m.deceased_date,
            education_institution: m.education_institution,
            education_start_date: m.education_start_date,
            education_end_date: m.education_end_date,
            education_subject: m.education_subject,
            education_level_studied: m.education_level_studied,
            education_country: m.education_country,
            education_course: m.education_course,
            work_employer: m.work_employer,
            work_industry: m.work_industry,
            work_start_date: m.work_start_date,
            work_end_date: m.work_end_date,
            work_position: m.work_position,
            individual_letter_salutation: m.individual_letter_salutation,
            individual_envelope_label_salutation: m.individual_envelope_label_salutation,
            School_name_custom_value: m.School_name_custom_value,
            Status_custom_value: m.Status_custom_value,
            student_no: m.stud_no,
          }

          finalExportList.push(tempRow)
        })
      }
      let finalRelationshipExportList = []
      if (this.relationshipDetailList.length > 0) {
        this.relationshipDetailList.forEach((m, index) => {
          let tempRow = {
            party1_id: m.party1_id,
            party1_reference: m.party1_reference,
            party2_id: m.party2_id,
            party2_reference: m.party2_reference,
            relationship: m.relationship,
          }

          finalRelationshipExportList.push(tempRow)
        })
      }
      if (this.selectedSchool !== '') {
        this.filterList[0].optionList.forEach(e => {
          if (e.id === this.selectedSchool) {
          }
        })
      }

      let dateSplit = this.dateRange.split(',')
      let fileName = 'Alumni withdrawals ' + dateSplit[0] + ' to ' + dateSplit[1]
      if (this.selectedSchool !== '') {
        this.filterList[0].optionList.forEach(e => {
          if (e.SchoolID === this.selectedSchool) {
            fileName += ' ' + e.SchoolName
          }
        })
      }
      let fileNameRelationship = fileName + ' relationship'

      Export_CSV.CsvExport(finalExportList, '', '', fileName)
      Export_CSV.CsvExport(finalRelationshipExportList, '', '', fileNameRelationship)
    },
  },
}
</script>

<style scoped></style>
